import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { QrcodeReader } from 'vue-qrcode-reader'

// グローバル変数で店舗情報を定義する（※実質店舗毎のカスタマイズになるためここに店舗特定情報を持つ）
// $mailと$useridは会員登録後に情報を書き換える
// 0014757 [debug_mode]{0=debug , 1=test , 2=operation},[develop_url],[test_url],[operation_url],[develop_liff_id],[test_liff_id],[operation_liff_id]
// [mobile_order] {0=使用せず,1=使用する} ※本来は[PROMOSHOP].[CHG_ORDER]の値を参照するべきだが店舗設定の一部としてここに定義する
let GlobalData = new Vue({
  data: {
    // みせめぐ店舗コード（本番用）
    $shopid:"651127",
    // みせめぐ店舗コード（試験用）
    $t_shopid: "656565",
    // みせめぐオーナーID（本番用）
    $prmid:"4307",
    // みせめぐオーナーID（試験用）
    $t_prmid: "4444",
    // みせめぐグループID（本番用）
    $mcgrp: "434",
    // みせめぐグループID（試験用）
    $t_mcgrp:"999",
    // TenpoVisor会社コード（本番用）
    $tv_compcd: "52060",
    // TenpoVisor会社コード（試験用）
    $t_tv_compcd: "51022",
    // TenpoVisor店舗コード（本番用）
    $tv_shopcd: "0001",
    // TenpoVisor店舗コード（試験用）
    $t_tv_shopcd: "9999",
    // TenpoVisorURL=DB名（本番用）
    $tv_url: "rearegi",
    // TenpoVisorURL=DB名（試験用）
    $t_tv_url: "rearegirearegi",
    // TenpoVisorURL=DB名（本番用）
    $tvdb_svr: "4",
    // TenpoVisorURL=DB名（試験用）
    $t_tvdb_svr: "14",
    // TenpoVisor店舗コード配列（本番用・カンマ区切りで複数指定）
    $tv_shop_array: "0001,0010",
    // TenpoVisor店舗コード配列（試験用・カンマ区切りで複数指定）
    $t_tv_shop_array: "0001,0002,0003,0004,0005,0006,0007,0008,0009,0010,0011,0012,0013",
    // 店舗名（アプリタイトル）
    $shopname:"みせめぐMini",
    // 店舗緯度（GPS受信不良の場合のデフォルト値）
    $shoplat:"35.7096945979444",
    // 店舗経度（GPS受信不良の場合のデフォルト値）
    $shoplng:"139.732414493284",
    // ポイント共有設定（0:共有しない, 1:共有する）
    $tv_pointshare:"1",
    // ポイント有効期限表示（0:表示しない, 1:表示する）
    $point_expiration_view: "1",
    // モバイルオーダー（0:使用しない, 1:使用する）
    //　※本来は[PROMOSHOP].[CHG_ORDER]の値を参照するべきだが店舗設定の一部としてここに定義する
    $mobile_order:"0",
    // 電話番号入力欄表示（0:表示しない, 1:表示する）
    $telephone_number:"0",
    // 選択店舗表示（0:表示しない, 1:表示する）
    $select_shop:"1",
    // デバッグモード（0:PC開発環境, 1:テスト, 2:運用）
    $debug_mode:"2",
    // PC開発環境のFQDN部分(port番号83は飯島のPC開発環境固有)
    $debug_url:"http://localhost:83/mg/",
  }
});
//グローバル変数の読み書きを可能にするメソッド
Vue.mixin({
  methods: {
    // みせめぐ店舗コード（本番用）
    $_shopid() {
      return GlobalData.$data.$shopid
    },
    $_setShopID(newShopID) {
      GlobalData.$data.$shopid = newShopID;
    },
    // みせめぐ店舗コード（試験用）
    $_t_shopid() {
      return GlobalData.$data.$t_shopid
    },
    $_setShopID_t(newShopID_t) {
      GlobalData.$data.$t_shopid = newShopID_t;
    },
    // みせめぐオーナーID（本番用）
    $_prmid() {
      return GlobalData.$data.$prmid
    },
    $_setPrmID(newPrmID) {
      GlobalData.$data.$prmid = newPrmID;
    },
    // みせめぐオーナーID（試験用）
    $_t_prmid() {
      return GlobalData.$data.$t_prmid
    },
    $_setPrmID_t(newPrmID_t) {
      GlobalData.$data.$t_prmid = newPrmID_t;
    },
    // みせめぐグループID（本番用）
    $_mcgrp() {
      return GlobalData.$data.$mcgrp
    },
    $_setMcgrp(newMcGrp) {
      GlobalData.$data.$mcgrp = newMcGrp;
    },
    // みせめぐグループID（試験用）
    $_t_mcgrp() {
      return GlobalData.$data.$t_mcgrp
    },
    $_setMcgrp_t(newMcGrp) {
      GlobalData.$data.$t_mcgrp = newMcGrp_t;
    },
    //　TenpoVisor会社コード（本番用）
    $_tv_compcd() {
      return GlobalData.$data.$tv_compcd
    },
    $_setTvCompCd(newTvCompCd) {
      GlobalData.$data.$tv_compcd = newTvCompCd;
    },
    //　TenpoVisor会社コード（試験用）
    $_t_tv_compcd() {
      return GlobalData.$data.$t_tv_compcd
    },
    $_setTvCompCd_t(newTvCompCd) {
      GlobalData.$data.$t_tv_compcd = newTvCompCd_t;
    },
    //　TenpoVisor店舗コード（本番用）
    $_tv_shopcd() {
      return GlobalData.$data.$tv_shopcd
    },
    $_setTvShopCd(newTvShopCd) {
      GlobalData.$data.$tv_shopcd = newTvShopCd;
    },
    //　TenpoVisor店舗コード（試験用）
    $_t_tv_shopcd() {
      return GlobalData.$data.$t_tv_shopcd
    },
    $_setTvShopCd(newTvShopCd_t) {
      GlobalData.$data.$t_tv_shopcd = newTvShopCd_t;
    },
    // -- 20241209
    //　TenpoVisor店舗コード（本番用）
    $_tv_url() {
      return GlobalData.$data.$tv_url
    },
    $_setTvUrl(newTvUrl) {
      GlobalData.$data.$tv_url = newTvUrl;
    },
    //　TenpoVisor店舗コード（試験用）
    $_t_tv_url() {
      return GlobalData.$data.$t_tv_url
    },
    $_setTvShopCd(newTvUrl_t) {
      GlobalData.$data.$t_tv_url = newTvUrl_t;
    },
    // --20241209
    // -- 20241209
    //　TenpoVisorDBサーバー識別コード（本番用）
    $_tvdb_svr() {
      return GlobalData.$data.$tvdb_svr;
    },
    $_setTvUrl(newDbSvr) {
      GlobalData.$data.$tvdb_svr = newDbSvr;
    },
    //　TenpoVisorDBサーバー識別コード（試験用）
    $_t_tvdb_svr() {
      return GlobalData.$data.$t_tvdb_svr;
    },
    $_setTvShopCd(newTvDbSvr_t) {
      GlobalData.$data.$t_tvdb_svr = newTvDbSvr_t;
    },
    // --20241209
    // TenpoVisor店舗コード配列（カンマ区切りで複数指定）
    $_tv_shop_array() {
      return GlobalData.$data.$tv_shop_array
    },
    $_setTvShopArray(newTvShopArray) {
      GlobalData.$data.$tv_shop_array = newTvShopArray;
    },
    // TenpoVisor店舗コード配列（カンマ区切りで複数指定）
    $_t_tv_shop_array() {
      return GlobalData.$data.$t_tv_shop_array;
    },
    $_setTvShopArray_t(newTvShopArray_t) {
      GlobalData.$data.$t_tv_shop_array = newTvShopArray_t;
    },
    // 店舗名（アプリタイトル）
    $_shopname() {
      return GlobalData.$data.$shopname;
    },
    $_setShopName(newShopName) {
      GlobalData.$data.$shopname = newShopName;
    },
    // 店舗緯度（GPS受信不良の場合のデフォルト値）
    $_shoplat() {
      return GlobalData.$data.$shoplat;
    },
    $_setShopLat(newShopLat) {
      GlobalData.$data.$shoplat = newShopLat;
    },
    // 店舗経度（GPS受信不良の場合のデフォルト値）
    $_shoplng() {
      return GlobalData.$data.$shoplng;
    },
    $_setShopLng(newShopLng) {
      GlobalData.$data.$shoplat = newShopLng;
    },
    // ポイント共有設定（0:共有しない, 1:共有する）
    $_tv_pointshare() {
      return GlobalData.$data.$tv_pointshare;
    },
    $_setTvPointShare(newTvPointShare) {
      GlobalData.$data.$tv_pointshare = newTvPointShare;
    },
    // ポイント有効期限表示（0:表示しない, 1:表示する）
    $_point_expiration_view() {
      return GlobalData.$data.$point_expiration_view;
    },
    $_setPointExpirationView(newPointExpirationView) {
      GlobalData.$data.$point_expiration_view = newPointExpirationView;
    },
    // モバイルオーダー（0:使用しない, 1:使用する）
    $_mobile_order() {
      return GlobalData.$data.$mobile_order;
    },
    $_setMobileOrder(newMobileOrder) {
      return GlobalData.$data.$mobile_order = newMobileOrder;
    },
    // 選択店舗表示（0:表示しない, 1:表示する）
    $_select_shop() {
      return GlobalData.$data.$select_shop;
    },
    $_setSelectShop(newSelectShop) {
      return GlobalData.$data.$select_shop = newSelectShop;
    },
    // 電話番号入力欄表示（0:表示しない, 1:表示する）
    $_telephone_number() {
      return GlobalData.$data.$telephone_number;
    },
    $_setTelephoneNumber(newTelephoneNumber) {
      return GlobalData.$data.$telephone_number = newTelephoneNumber;
    },
    // デバッグモード（0:PC開発環境, 1:テスト, 2:運用）
    $_debug_mode() {
      return GlobalData.$data.$debug_mode;
    },
    $_setDebugMode(newDebugMode) {
      GlobalData.$data.$debug_mode = newDebugMode;
    },
    // PC開発環境のFQDN部分
    $_debug_url() {
      return GlobalData.$data.$debug_url;
    },
    $_setDebugUrl(newDebugUrl) {
      GlobalData.$data.$debug_url = newDebugUrl;
    } 
  },
  computed: {
    // みせめぐ店舗コード（本番用）
    $shopid: {
      get: function () { return GlobalData.$data.$shopid },
      set: function (newShopID) { GlobalData.$data.$shopid = newShopID; }
    },
    // みせめぐ店舗コード（試験用）
    $t_shopid: {
      get: function () { return GlobalData.$data.$t_shopid },
      set: function (newShopID_t) { GlobalData.$data.$t_shopid = newShopID_t; }
    },
    // みせめぐオーナーID（本番用）
    $prmid: {
      get: function () { return GlobalData.$data.$prmid },
      set: function (newPrmID) { GlobalData.$data.$prmid = newPrmID; }
    },
    // みせめぐオーナーID（試験用）
    $t_prmid: {
      get: function () { return GlobalData.$data.$t_prmid },
      set: function (newPrmID_t) { GlobalData.$data.$t_prmid = newPrmID_t; }
    },
    // みせめぐグループID（本番用）
    $mcgrp: {
      get: function () { return GlobalData.$data.$mcgrp },
      set: function (newMcGrp) { GlobalData.$data.$mcgrp = newMcGrp; }
    },
    // みせめぐグループID（試験用）
    $t_mcgrp: {
      get: function () { return GlobalData.$data.$t_mcgrp },
      set: function (newMcGrp_t) { GlobalData.$data.$t_mcgrp = newMcGrp_t; }
    },
    // TenpoVisor会社コード（本番用）
    $tv_compcd: {
      get: function () { return GlobalData.$data.$tv_compcd },
      set: function (newTvCompCd) { GlobalData.$data.$tv_compcd = newTvCompCd; }
    },
    // TenpoVisor会社コード（試験用）
    $t_tv_compcd: {
      get: function () { return GlobalData.$data.$t_tv_compcd },
      set: function (newTvCompCd_t) { GlobalData.$data.$t_tv_compcd = newTvCompCd_t; }
    },
    // TenpoVisor店舗コード（本番用）
    $tv_shopcd: {
      get: function () { return GlobalData.$data.$tv_shopcd },
      set: function (newTvShopCd) { GlobalData.$data.$tv_shopcd = newTvShopCd; }
    },
    // TenpoVisor店舗コード（試験用）
    $t_tv_shopcd: {
      get: function () { return GlobalData.$data.$t_tv_shopcd },
      set: function (newTvShopCd_t) { GlobalData.$data.$t_tv_shopcd = newTvShopCd_t; }
    },
    // ---- 20241209
    // TenpoVisorURL（本番用）
    $tv_url: {
      get: function () { return GlobalData.$data.$tv_url },
      set: function (newTvUrl) { GlobalData.$data.$tv_url = newTvUrl; }
    },
    // TenpoVisorURL（試験用）
    $t_tv_url: {
      get: function () { return GlobalData.$data.$t_tv_url },
      set: function (newTvUrl_t) { GlobalData.$data.$t_tv_url = newTvUrl_t; }
    },
    // ---- 20241209
    // ---- 20241209
    // TenpoVisorURL（本番用）
    $tv_url: {
      get: function () { return GlobalData.$data.$tvdb_svr },
      set: function (newTvDbSvr) { GlobalData.$data.$tvdb_svr = newTvDbSvr; }
    },
    // TenpoVisorURL（試験用）
    $t_tv_url: {
      get: function () { return GlobalData.$data.$t_tvdb_svr },
      set: function (newTvDbSvr_t) { GlobalData.$data.$t_tvdb_svr = newTvDbSvr_t; }
    },
    // ---- 20241209
    // TenpoVisor店舗コード配列（カンマ区切りで複数指定）
    $tv_shop_array: {
      get: function () { return GlobalData.$data.$tv_shop_array },
      set: function (newTvShopArray) { GlobalData.$data.$tv_shop_array = newTvShopArray; }
    },
    // TenpoVisor店舗コード配列（カンマ区切りで複数指定）
    $t_tv_shop_array: {
      get: function () { return GlobalData.$data.$t_tv_shop_array },
      set: function (newTvShopArray_t) { GlobalData.$data.$t_tv_shop_array = newTvShopArray_t; }
    },
    // 店舗名（アプリタイトル）
    $shopname: {
      get: function () { return GlobalData.$data.$shopname },
      set: function (newShopName) { GlobalData.$data.$shopname = newShopName; }
    },
    // 店舗緯度（GPS受信不良の場合のデフォルト値）
    $shoplat: {
      get: function () { return GlobalData.$data.$shoplat },
      set: function (newShopLat) { GlobalData.$data.$shoplat = newShopLat; }
    },
    // 店舗経度（GPS受信不良の場合のデフォルト値）
    $shoplng: {
      get: function () { return GlobalData.$data.$shoplng },
      set: function (newShopLng) { GlobalData.$data.$shoplng = newShopLng; }
    },
    // ポイント共有設定（0:共有しない, 1:共有する）
    $tv_pointshare: {
      get: function () { return GlobalData.$data.$tv_pointshare },
      set: function (newTvPointShare) { GlobalData.$data.$tv_pointshare = newTvPointShare; }
    },
    // ポイント有効期限表示（0:表示しない, 1:表示する）
    $point_expiration_view: {
      get: function () { return GlobalData.$data.$point_expiration_view },
      set: function (newPointExpirationView) { GlobalData.$data.$point_expiration_view = newPointExpirationView; }
    },
    // 選択店舗表示（0:表示しない, 1:表示する）
    $select_shop: {
      get: function () { return GlobalData.$data.$select_shop },
      set: function (newSelectShop) { GlobalData.$data.$select_shop = newSelectShop; }
    },
    // モバイルオーダー（0:使用しない, 1:使用する）
    $mobile_order: {
      get: function () { return GlobalData.$data.$mobile_order },
      set: function (newMobileOrder) { GlobalData.$data.$mobile_order = newMobileOrder; }
    },
    // 電話番号入力欄表示（0:表示しない, 1:表示する）
    $telephone_number: {
      get: function () { return GlobalData.$data.$telephone_number },
      set: function (newTelephoneNumber) { GlobalData.$data.$telephone_number = newTelephoneNumber; }
    },
    // デバッグモード（0:PC開発環境, 1:テスト, 2:運用）
    $debug_mode: {
      get: function () { return GlobalData.$data.$debug_mode },
      set: function (newDebugMode) { GlobalData.$data.$debug_mode = newDebugMode; }
    },
    // PC開発環境のFQDN部分
    $debug_url: {
      get: function () { return GlobalData.$data.$debug_url },
      set: function (newDebugUrl) { GlobalData.$data.$debug_url = newDebugUrl; }
    }
  }
})
Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('my-component', {
  components: { QrcodeReader },
})

Vue.config.devtools = true;
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
